module.exports = __webpack_public_path__ + "static/media/19.6850613a.png";